import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    isEditDetails: false,
    userName: '',
    userEmail: '',
    code: 'JOB0001',
    quizName: "",
    questions: [],
    quizId: 0,
    duration: 0,
    expiryTimestamp: '',
    id: 0,
    aboutJob: '',
    aboutCompany: '',
    applicationType: '',
    companyname: '',
    companyLogo: '',
    codeAssociation: '',
    position: '',
    addInfoOne: '',
    addInfoTwo: '',
    userId: '',
    isNormalAssesment: null,
    token: '',
    isTimeUp: false,
    count: 0,
    isSaveQuiz: true,
    externalQuizLink: '',
    isQuiz: false,
    step: 1,
    type: '',
    fromLink: false,
    currentStep: 0

}


const roundSlice = createSlice({
    name: 'roundData',
    initialState,
    reducers: {
        updateData: (state, action) => {

            const { field, value } = action.payload
            state[field] = value
        }
    }
})

export const { updateData } = roundSlice.actions
export default roundSlice.reducer